module.exports = __webpack_public_path__ + "img/natural.867e797c.jpg";